import DOMPurify from "dompurify";

const SANITIZE_CONFIG = {
  WHOLE_DOCUMENT: true,
  ADD_TAGS: ["style"],
};

export const sanitizeDocumentHtml = (html) => {
  if (!html || typeof html !== "string") return "";
  return DOMPurify.sanitize(html, SANITIZE_CONFIG);
};

export default sanitizeDocumentHtml;
